<div class="why-choose-cont">


  <div class="container " [dir]="language == 'ar' ? 'rtl' : 'ltr'">
    <h3>
      {{ data.details.title }}
    </h3>

    <div class="row justify-content-between">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let mainservice of data.details.services">
        <!-- Use anchor tag for navigation -->

        <a *ngIf="!data.details.isDetails" class="card-content " [ngStyle]="{
          'text-decoration': 'none',
          display: 'block'
        }">

          <div class="card-image" *ngIf="mainservice.imageIconPath">
            <img [src]="mainservice.imageIconPath" alt="mainservice.imageAlt">
          </div>
          <div class="card-title" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
            {{ mainservice.title }}
          </div>


          <div class="card-description">
            <div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
              {{ mainservice.summary }}
            </div>
          </div>
        </a>
        <a *ngIf="data.details.isDetails" class="card-content card-blue " [ngStyle]="{
          'text-decoration': 'none',
          color: 'inherit',
          display: 'block'
        }">
          <div class="card-header">
            <div class="card-image" *ngIf="mainservice.imageIconPath">
              <img [src]="mainservice.imageIconPath" alt="mainservice.imageAlt">
            </div>

            <div class="card-title" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
              {{ mainservice.title }}
            </div>
          </div>
          <div class="card-description">
            <div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
              {{ mainservice.summary }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
<hr>